module.exports = __webpack_public_path__ + "icon_vert_telecommunication.svg?2248d21bdb857eab9445b2153191b592";


//////////////////
// WEBPACK FOOTER
// ./src/img/domaine_activite/icon_vert_telecommunication.svg
// module id = 120
// module chunks = 0